/**
 * Test Guidance is stored as Markdown (ADR-0002). In-text links to a spec's
 * Reference Images use a custom `ref-image:{id}` scheme so they resolve from
 * the offline cache by id, distinct from `https://` website links.
 */

const REF_IMAGE_PREFIX = 'ref-image:';

/** Build the markdown link for an in-text reference-image link. */
export const buildReferenceImageLink = (id: number, label: string): string =>
  `[${label}](${REF_IMAGE_PREFIX}${id})`;

/**
 * Parse a link href. Returns the numeric Reference Image id for a well-formed
 * `ref-image:{id}` href, or null for anything else (websites, mailto, malformed).
 */
export const parseReferenceImageHref = (href: string): number | null => {
  if (!href.startsWith(REF_IMAGE_PREFIX)) {
    return null;
  }
  const raw = href.slice(REF_IMAGE_PREFIX.length);
  if (!/^\d+$/.test(raw)) {
    return null;
  }
  return Number(raw);
};
